import React from 'react';

import { CardAttendance } from 'views/Attendance/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <CardAttendance />
      </div>
    </div>
  );
};
